var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHome21X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "119px",
    height: "117px",
    viewBox: "0 0 119 117",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-home-2@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Prototype",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Landing",
    transform: "translate(-631.000000, -828.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3-column",
    transform: "translate(220.000000, 688.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(0.000000, 108.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01-copy",
    transform: "translate(320.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-home-2",
    transform: "translate(91.000000, 33.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(12.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#E9EAEB",
    fillRule: "nonzero",
    cx: 42.643,
    cy: 47.5,
    r: 41.837
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.64,65.537 C44.416,62.044 41.117,59.703 37.412,59.703 L25.21,59.703 L25.21,47.5 L28.696,50.986 C28.696,50.986 36.248,50.986 40.898,50.986 C48.872,50.986 47.871,42.27 47.871,42.27 L35.669,42.27 L23.467,30.068 L16.494,30.068 C12.644,30.068 9.522,33.19 9.522,37.041 L9.522,63.188 C9.522,68.963 14.205,73.647 19.981,73.647 L35.669,73.647 L46.128,94.566 L55.798,94.566 L45.64,65.537 Z",
    id: "Shape",
    fill: "#C1F6FD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.724,24.674 C16.857,24.674 13.008,20.692 13.008,15.78 L13.008,12.814 C13.008,7.901 16.857,3.92 21.724,3.92 C26.592,3.92 30.44,7.901 30.44,12.814 L30.44,15.78 C30.439,20.692 26.591,24.674 21.724,24.674 Z",
    id: "Shape",
    stroke: "#2A5082",
    strokeWidth: 2,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.21,
    y1: 50.986,
    x2: 86.222,
    y2: 50.986,
    id: "Shape",
    stroke: "#2A5082",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    stroke: "#2A5082",
    strokeWidth: 2,
    points: "51.357 44.014 61.817 44.014 61.817 50.986"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    stroke: "#2A5082",
    strokeWidth: 2,
    points: "68.79 50.986 68.79 44.014 75.763 44.014 79.249 44.014 79.249 23.095 70.533 23.095"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.79,37.041 L63.561,37.041 L63.561,0.434 L68.79,0.434 C70.715,0.434 72.276,1.995 72.276,3.92 L72.276,33.554 C72.276,35.48 70.715,37.041 68.79,37.041 Z",
    id: "Shape",
    stroke: "#2A5082",
    strokeWidth: 2,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.237,
    y1: 84.106,
    x2: 18.237,
    y2: 94.566,
    id: "Shape",
    stroke: "#2A5082",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.128,94.566 L35.669,73.647 L19.98,73.647 C14.204,73.647 9.521,68.963 9.521,63.188 L9.521,37.041 C9.521,33.19 12.643,30.068 16.493,30.068 L23.466,30.068 L35.668,42.27 L47.87,42.27 C47.87,42.27 48.871,50.986 40.897,50.986 C36.248,50.986 28.695,50.986 28.695,50.986 L18.237,40.527",
    id: "Shape",
    stroke: "#2A5082",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.21,47.5 L25.21,59.703 L37.412,59.703 C41.117,59.703 44.416,62.044 45.64,65.537 L55.799,94.566",
    id: "Shape",
    stroke: "#2A5082",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.548,33.555 L2.548,66.676 C2.548,74.376 8.793,80.62 16.493,80.62 L32.182,80.62",
    id: "Shape",
    stroke: "#2A5082",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    stroke: "#2A5082",
    strokeWidth: 2,
    points: "2.548 59.703 16.494 59.703 21.724 66.676"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 89.709,
    y1: 50.986,
    x2: 93.195,
    y2: 50.986,
    id: "Shape",
    stroke: "#2A5082",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("line", {
    x1: 11.345,
    y1: 113.822,
    x2: 103,
    y2: 113.822,
    id: "Shape",
    stroke: "#2A5082",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 104.452,
    y1: 113.822,
    x2: 111.785,
    y2: 113.822,
    id: "Shape",
    stroke: "#2A5082",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114.334,
    y1: 113.822,
    x2: 118,
    y2: 113.822,
    id: "Shape",
    stroke: "#2A5082",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.834,
    y1: 113.822,
    x2: 8.5,
    y2: 113.822,
    id: "Shape",
    stroke: "#2A5082",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 102.283,
    y1: 25.849,
    x2: 102.283,
    y2: 33.972,
    id: "Shape",
    stroke: "#BCC0C4",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 106.344,
    y1: 29.91,
    x2: 98.222,
    y2: 29.91,
    id: "Shape",
    stroke: "#BCC0C4",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#BCC0C4",
    strokeWidth: 2,
    cx: 110.405,
    cy: 10.958,
    r: 4.062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.936,10.652 L46.287,10.652 C45.349,8.819 43.142,6.93 40.57,6.93 C39.754,6.93 38.976,7.123 38.262,7.41 C36.828,3.588 33.152,0.721 28.83,0.721 C23.269,0.721 18.761,6.987 18.75,10.653 L3.945,10.653",
    id: "Shape",
    stroke: "#BCC0C4",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.109,
    y1: 25.316,
    x2: 0.278,
    y2: 25.316,
    id: "Shape",
    stroke: "#BCC0C4",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.775,
    y1: 25.316,
    x2: 20.443,
    y2: 25.316,
    id: "Shape",
    stroke: "#BCC0C4",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 62.604,
    y1: 10.652,
    x2: 66.268,
    y2: 10.652,
    id: "Shape",
    stroke: "#BCC0C4",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 69.936,
    y1: 10.652,
    x2: 73.602,
    y2: 10.652,
    id: "Shape",
    stroke: "#BCC0C4",
    strokeWidth: 2
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome21X);
export default __webpack_public_path__ + "static/media/icon-home-2@1x.3b444027d4042189c8faa4a1e68b0d0f.svg";
export { ForwardRef as ReactComponent };